import React from 'react'
import { useTranslation } from 'react-i18next';
import { MultiSelect } from "react-multi-select-component";

export const CustomMultiSelect = ({ options, selected, setSelected, isLoading }) => {

    const { t } = useTranslation()
    return (
        <>
            <MultiSelect
                options={options}
                value={selected}
                onChange={setSelected}
                hasSelectAll={false}
                isLoading={isLoading}
                // ItemRenderer={()}
                className='text-sm text-gray-800'
                overrideStrings={{ selectSomeItems: t('select'), search: t('search'), noOptions: t('noOptions')  ,  allItemsAreSelected : t('allItemsAreSelected')}}
                ItemRenderer={({ checked,
                    option,
                    onClick,
                    disabled, }) => <div style={{display:'flex', alignItems:'center'}} className={`item-renderer  gap-2 items-center ${disabled ? "disabled" : ""}`}>
                        <input
                            type="checkbox"
                            onChange={onClick}
                            checked={checked}
                            className='rounded'
                            tabIndex={-1}
                            disabled={disabled}
                        />
                        <div  >{option.label}</div>
                    </div>}

            // labelledBy="Select"
            />
        </>
    )
}
